import React from 'react';
import '../../styles/Footer.css';
import linkedinlogo from '../../assets/linkedinlogo.png';
import { BUILT_LINKEDIN_URL } from '../../constants/Constants';
import Text from './Text';

const Footer: React.FC = () => {
  return (
    <div className="footer-container col-lg-8 col-md-12 col-sm-12">
      <Text className="medium-regular text-color-grey">
        © 2024 BUILT All rights reserved.
      </Text>
      <a href={BUILT_LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
        <img
          src={linkedinlogo}
          alt="Built Linkedin Profile"
          className="linkedin-logo"
        />
      </a>
    </div>
  );
};

export default Footer;
